import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import MobileInput from '@/common/components/base/input/mobileInput/MobileInput';
import { MOBILE_NUMBER_RULE } from '@/common/components/base/input/mobileInput/mobileInput.rules';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import { ADDRESS_RULE } from '@/common/utils/rules/address.rules';
import { PHONE_NUMBER_RULE } from '@/common/utils/rules/phoneNumber.rules';
import { POSTAL_CODE_RULE } from '@/common/utils/rules/postalCode.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import ConfirmDriverModal from '@/modules/adjusterReportModules/IncidentParticipants/components/modals/ConfirmDriverModal';
import { ADJUSTER_REPORT_BODY_DAMAGE_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
import { BodyDriverInfoTypeForm } from '@/modules/adjusterReportModules/Insurer-information/pages/driver-owner/driverInfo/BodyDriverInfo.type';
import { patchBodyContactDriverQueryOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyContactDriverData/patchBodyContactDriverQueryOptions';
import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

const BodyContactInfo: React.FC = () => {
  const methods = useFormContext<BodyDriverInfoTypeForm>();
  const isOwnerDriver = methods?.watch('personal_information.is_owner_driver');

  const [openModal, setOpenModal] = React.useState(false);
  const loading = false;
  const { mutate: patchDriverContactInfo } = useMutation({
    ...patchBodyContactDriverQueryOptions(),
    onSuccess: () => {
      isOwnerDriver ? setOpenModal(true) : null;
    },
  });
  const { id } = useParams();
  const navigate = useNavigate();
  const onSubmit = (formData: BodyDriverInfoTypeForm) => {
    patchDriverContactInfo(
      {
        id: Number(id),
        data: {
          ...formData.contact_information,
          city_code:
            formData.contact_information?.city_code === ''
              ? null
              : formData.contact_information?.city_code,
          phone:
            formData.contact_information?.phone === ''
              ? null
              : formData.contact_information?.phone,
          address:
            formData.contact_information.address === ''
              ? null
              : formData.contact_information.address,
          postal_code:
            formData.contact_information.postal_code === ''
              ? null
              : formData.contact_information.postal_code,
        },
      },
      {
        onSuccess: () => isOwnerDriver === 'true' && navigate(-1),
      },
    );
  };
  const previousStep = () => {
    navigate(
      ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_INFORMATION({
        id: id!,
      }).DRIVER_OWNER_INFORMATION.certificate,
      {
        replace: true,
      },
    );
  };

  return (
    <Flex direction="column" gap={32}>
      {isOwnerDriver === 'false' && (
        <ConfirmDriverModal
          open={openModal}
          setOpenModal={setOpenModal}
          cancelNavigate={() => navigate(-1)}
          navigateTo={() =>
            navigate(
              ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_INFORMATION({
                id: id!,
              }).DRIVER_OWNER_INFORMATION.owner,
              { replace: true },
            )
          }
        />
      )}
      <Box>
        <MobileInput
          name="contact_information.phone_number"
          label="تلفن همراه "
          rules={{ ...MOBILE_NUMBER_RULE }}
        />
      </Box>
      <Box display="flex" flexDirection="row" gap="10px">
        <Box flexBasis={'80%'}>
          <TextInput
            name="contact_information.phone"
            label="تلفن ثابت"
            key={'phone'}
            rules={{ required: requiredText, ...PHONE_NUMBER_RULE }}
            max={8}
            placeholder="XX-XX-XX-XX"
            noCharInput={true}
            direction="ltr"
          />
        </Box>
        <Box flexBasis={'30%'}>
          <TextInput
            name="contact_information.city_code"
            key={'city_code'}
            rules={{
              minLength: { message: 'پیش شماره شهر 3 رقمی است', value: 3 },
              required: requiredText,
            }}
            max={3}
            placeholder="کد شهر"
            noCharInput={true}
            direction="ltr"
          />
        </Box>
      </Box>
      <Box>
        <TextInput
          label="کدپستی"
          name="contact_information.postal_code"
          placeholder="کدپستی را وارد کنید"
          rules={{ ...POSTAL_CODE_RULE }}
          optionalLabel
          noCharInput
          defaultValue=""
          max={10}
        />
      </Box>
      <Box>
        <TextInput
          label="آدرس"
          name="contact_information.address"
          placeholder="آدرس را وارد کنید"
          rules={{ ...ADDRESS_RULE }}
          optionalLabel
          defaultValue=""
        />
      </Box>
      <Flex w="100%" gap={16} mb="1rem">
        <Button
          fullWidth
          variant="outlined"
          onClick={() => {
            previousStep();
            methods.clearErrors();
            methods.trigger('certificate_information');
          }}
        >
          مرحله قبل
        </Button>{' '}
        <LoadingButton
          onClick={methods.handleSubmit(onSubmit)}
          loading={loading}
          fullWidth
          disabled={!methods?.formState?.isValid}
        >
          ثبت
        </LoadingButton>
      </Flex>
    </Flex>
  );
};

export default BodyContactInfo;
